var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseBtn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1200pt",
    height: "1200pt",
    viewBox: "0 0 1200 1200",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m653.05 600 220.95-220.95c14.648-14.648 14.648-38.398 0-53.051-14.648-14.648-38.398-14.648-53.051 0l-220.95 220.95-220.95-220.95c-14.648-14.648-38.398-14.648-53.051 0-14.648 14.648-14.648 38.398 0 53.051l220.95 220.95-220.95 220.95c-14.648 14.648-14.648 38.398 0 53.051 7.3008 7.3008 16.898 11 26.5 11s19.199-3.6484 26.5-11l220.95-220.95 220.95 220.95c7.3008 7.3008 16.898 11 26.5 11 9.6016 0 19.199-3.6484 26.5-11 14.648-14.648 14.648-38.398 0-53.051l-220.95-220.95z",
    fill: "#c6dde2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseBtn);
export default __webpack_public_path__ + "static/media/closeBtn.3c9b6a8bf2ab9e4e518dd2ebfb125300.svg";
export { ForwardRef as ReactComponent };